"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Alert = _interopRequireDefault(require("../Alert"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const Banner = ({
  children,
  danger,
  info,
  success,
  header,
  actionButton,
  ...restProps
}) => {
  const isDefault = !success && !danger && !info;
  return (0, _jsxRuntime.jsx)(_Alert.default, {
    "aria-live": "assertive",
    rounded: true,
    primary: isDefault,
    success: success,
    danger: danger,
    info: info,
    ...restProps,
    children: (0, _jsxRuntime.jsxs)(_styles.Wrapper, {
      children: [(0, _jsxRuntime.jsxs)(_styles.LeftSide, {
        children: [header, children && (0, _jsxRuntime.jsx)(_styles.Content, {
          children: children
        })]
      }), actionButton && (0, _jsxRuntime.jsx)(_styles.RightSide, {
        children: actionButton
      })]
    })
  });
};
var _default = exports.default = Banner;